const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

const formatDate = dateString => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {timeZone: 'UTC'});
};

const formatIsoDate = dateString => {
  const date = new Date(dateString);
  return date.toISOString().slice(0, 10);
};

const centsToDollars = cents => currencyFormatter.format(cents / 100);

export {currencyFormatter, formatDate, formatIsoDate, centsToDollars};



// WEBPACK FOOTER //
// ./src/util/Utils.js